module.exports = __webpack_public_path__ + "img/LV3.bdf09dd8.webp";